/**
 * Helpers: Timings
 * ------------------------------------------------------------------------------
 * - Standard animation timings for various states.
 */
export default {
  active: 'is-active',
  hidden: 'is-hidden',
  loading: 'is-loading',
  locked: 'is-locked',
  pending: 'is-pending',
  waiting: 'is-waiting',
  success: 'is-success',
  sticky: 'is-sticky',
}
